<template>
	<div class="group-component" v-bind:class="{
        collapsed: !show,
    }">
		<div class="group-headline" v-on:click="toggle">
            <SvgIcon name="toggle" />
            <h1>{{ title }}</h1>
        </div>

        <div v-show="show">
		    <slot />
        </div>
	</div>
</template>

<script>
export default {
  props: [
    'title',
    'collapsed'
  ],
  data: () => ({
    show: true
  }),
  methods: {
    toggle () {
      this.show = !this.show
    }
  },
  created () {
    if (this.collapsed) {
      this.show = false
    }
  }
}
</script>

<style lang="less">
    .group-component {
    	position: relative;
        border: 1px solid #e0e0e0;
        padding: 40px;
        .group-headline {
            cursor: pointer;
        	position: absolute;
        	top: -16px;
        	left: 10px;
        	padding-left: 10px;
        	padding-right: 20px;
        	background: #fff;
            display: flex;
            align-items: center;
            h1 {
                font-size: 17px;
                font-weight: 900;
                text-transform: uppercase;
            }
            .svg-icon {
                transition: 120ms;
                transform: rotate(90deg);
                margin-right: 6px;
                svg {
                    width: 20px;
                    height: 20px;
                    // fill: #666;
                }
            }
        }
        &.collapsed {
            padding-bottom: 0px;
            .group-headline {
                .svg-icon {
                    transform: rotate(0deg);
                }
            }
        }
    }
</style>
